import { AlphaJCircleOutlineIcon } from './AlphaJCircleOutlineIcon';

/**
 * author: Contributors
 * id 0A0B3839-C0D3-422A-B688-E59F4927AA6F
 * name alpha-j-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-j-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetJCircleOutlineIcon = AlphaJCircleOutlineIcon;
export default AlphabetJCircleOutlineIcon